module.exports = __webpack_public_path__ + "assets/img/iot.4b5dd2bb.png";